module.exports = __webpack_public_path__ + "img/BETSY_VideoLoading_0.c33a86f0.png";